import React from "react";
import { Button } from "reactstrap";
function schoolToggle({ id, isVerified, schoolName, submit }) {
  return (
    <div>
      <Button
        color={isVerified ? "primary" : "danger"}
        className={isVerified ? "pe-4 btn-sm" : "btn-sm"}
        onClick={() =>
          submit({
            schoolId: id,
            schoolName: schoolName,
            isVerified: !isVerified,
          })
        }
      >
        {isVerified ? "Is Verified" : "Not Verified"}
      </Button>
    </div>
  );
}

export default schoolToggle;